import { FC } from 'react';

import { Loader } from '@gem/ui-kit';
import { getMascotImageSrc } from '@gem/utils';

import { BrandBackground } from 'APP/components/BrandBackground/BrandBackground';
import { ImageTheme } from 'APP/components/ImageTheme/ImageTheme';
import { WrapperContent } from 'APP/unauthorized/Pages/Components/WrapperContent/WrapperContent';

import { ICallPreviewPresenter } from '../CallPreview.presenter';
import styles from './CallPreviewLoader.styles.m.css';

interface ICallPreviewLoaderProps {
  presenter: ICallPreviewPresenter;
}

// TODO: layout рассмотреть в будущем использование AuthorizationLayout
export const CallPreviewLoader: FC<ICallPreviewLoaderProps> = ({ presenter }) => {
  const { mainBackgroundLight, mainBackgroundDark } = PROJECT_CONFIG.imageAssets;

  return (
    <>
      <BrandBackground
        isDarkMode={presenter.isDarkMode}
        backgroundSrc={{
          light: getMascotImageSrc(mainBackgroundLight),
          dark: getMascotImageSrc(mainBackgroundDark),
        }}
      />
      <WrapperContent>
        <div className={styles.logo}>
          <ImageTheme
            lightImageName={PROJECT_CONFIG.imageAssets.mainLogoLight}
            darkImageName={PROJECT_CONFIG.imageAssets.mainLogoDark}
          />
        </div>
        <div className={styles.loader}>
          <Loader
            color="base-80"
            size="medium"
          />
        </div>
      </WrapperContent>
    </>
  );
};
